module.exports = __webpack_public_path__ + "img/WhatsApp Image 2020-06-07 at 3.58.42 PM (1).a7b8d0d3.jpeg";